// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  TelemetryStreamType,
  AlertCondition,
  AlertSeverity,
} from "./types";

export default {
  projectId: __t.u32(),
  twinId: __t.option(__t.string()),
  streamName: __t.string(),
  get streamType() {
    return TelemetryStreamType;
  },
  get condition() {
    return AlertCondition;
  },
  get severity() {
    return AlertSeverity;
  },
  name: __t.string(),
  description: __t.string(),
  enabled: __t.bool(),
};
